import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

function ProtectedRoute({ component: Component, ...props }) {
  const { currentUser } = useAuth();

  return (
    <Route
      {...props}
      render={(props) =>
        currentUser ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  );
}

export default ProtectedRoute;
